import { Fragment, useState } from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../../common/Loader';

const initialValues = {
    currentPassword: "",
    newPassword: "",
    verifyPassword: ""
}

const objErrorValues = {
    isShow: false,
    isError: false,
    message: ""
}

var base_url = window.origin + '/classic/';
const { REACT_APP_TIMELIVE_API_URL, NODE_ENV } = process.env;

export function ChangePassword() {
    const [resetValues, setResetValues] = useState<any | ''>(initialValues);
    const [errorValues, setErrorValues] = useState<any | ''>(objErrorValues);
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const changePassword = async (value: any) => {
        if (NODE_ENV === "development") {
            base_url = REACT_APP_TIMELIVE_API_URL as string;
        }
        if (value.currentPassword === value.verifyPassword) {
            setErrorValues({
                ...errorValues,
                isShow: true,
                isError: true,
                message: "The New Password cannot be the same as the Current Password. Please enter a new password."
            });
        } else {
            setIsLoading(true);
            setErrorValues({
                ...errorValues,
                isShow: false,
                isError: false,
                message: ""
            });
            try {
                // `https://localdebug2.livetecs.com/api/Account/ResetPassword/`
                const response: any = await fetch(`${base_url}api/Account/ChangePassword/`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        "CrrentPassword": value.currentPassword,
                        "NewPassword": value.verifyPassword,
                        "Email": location.state.email,
                        "IsForcePasswordChange": location.state.isForcePasswordChange,
                        "IsPasswordExpired": location.state.isPasswordExpired
                    })
                });
                const json = await response.json();
                if (json.StatusCode === "200") {
                    alert(json.message);
                    navigate('/auth/login');
                    // setErrorValues({
                    //     ...errorValues,
                    //     isShow: true,
                    //     isError: false,
                    //     //message: json.message
                    // });
                    // ShowSwalWithSuccessButton("Timesheet Submission Confirmation", json.message, "Okay")
                    //     .then((result) => {
                    //         if (result) {
                    //             navigate('/auth/login');
                    //         }
                    //     });
                } else if (json.StatusCode === "404") {
                    setErrorValues({
                        ...errorValues,
                        isShow: true,
                        isError: true,
                        message: json.message
                    });
                } else {
                    setErrorValues({
                        ...errorValues,
                        isShow: true,
                        isError: true,
                        message: json.message
                    });
                }
            } catch {

            } finally {
                setIsLoading(false);
            }
        }
    }

    return (
        <>
            {isLoading && <Loader />}
            <div className="d-flex flex-column flex-root" style={{
                backgroundImage: `url(${toAbsoluteUrl('/media/backgrounds/container-bg.svg')})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '100vh',
                width: '100%',
                position: 'relative'
                //backgroundColor: '#f2f6f8'
            }}>
                <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                    <div className="d-flex flex-lg-row-fluid">
                        <div className="d-flex flex-column flex-center pb-0 pb-lg-10 p-10 w-100">
                            <img className="theme-light-show mx-auto mw-100 w-150px w-lg-500px mb-10" src={toAbsoluteUrl('/media/backgrounds/LoginBackground.svg')} alt="" />
                            <h1 className="fs-2qx fw-bold text-center mb-7 textDarkBlue">
                Fast, Efficient and Productive
              </h1>
              <div className="color-TextDarkBlue fs-base text-center fw-semibold">
                Discover the ultimate time tracking software designed to streamline your business operations.
                <br /> Our intuitive platform simplifies time and expense,<br /> ensuring accuracy and efficiency in managing your projects and its expenses.
              </div>
                            {/* <div className="text-gray-600 fs-base text-center fw-semibold">
                                In this kind of post, <a href="#" className="opacity-75-hover text-primary me-1">the blogger</a>
                                introduces a person they’ve interviewed <br /> and provides some background information about
                                <a href="#" className="opacity-75-hover text-primary me-1">the interviewee</a>
                                and their <br /> work following this is a transcript of the interview.
                            </div> */}
                        </div>
                    </div>
                    <Formik
                        initialValues={resetValues}
                        enableReinitialize={true}
                        onSubmit={values => { changePassword(values) }}
                        validationSchema={yup.object().shape({
                            currentPassword: yup
                                .string()
                                .label('Current Password')
                                .required(),
                            newPassword: yup
                                .string()
                                .label('New Password')
                                .required()
                                .matches(
                                    /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}).*$/,
                                    'Must have at least 1 number, 1 special character, and must be at least 8 characters.'
                                ),
                            verifyPassword: yup
                                .string()
                                .label('Re-Type Password')
                                .required()
                                .oneOf([yup.ref('newPassword')], 'Passwords must match')
                        })}
                    >
                        {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue, validateForm }) => (
                            <Fragment>
                                <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-12">
                                    <div className="bg-body d-flex flex-column flex-center rounded-4 w-md-525px p-10 loginShadow">
                                        <div className="d-flex flex-center flex-column align-items-stretch h-lg-100 w-md-425px" >
                                            <div className="d-flex flex-column flex-column-fluid pb-15 pb-lg-20 mt-4">
                                                <div className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework">
                                                    <div className="text-center mb-10">
                                                        <img
                                                            alt='Logo'
                                                            src={toAbsoluteUrl('/media/logos/LivetecsLogo.svg')}
                                                            className='w-md-150px app-sidebar-logo-default theme-light-show mb-4'
                                                        />
                                                        <h3 className="card-title fw-bold signTitle">
                                                            You must change your password
                                                        </h3>
                                                        <div className="text-gray-500 fs-6">
                                                            Let’s get you back in. Enter your new password below.
                                                        </div>
                                                    </div>
                                                    {errorValues.isShow &&
                                                        <div id="validationerror" className={errorValues.isError ? "alert alert-danger" : "alert alert-success"}>
                                                            <strong>{errorValues.isError ? "Error!" : "Success"}</strong>
                                                            <ul>
                                                                <li>{errorValues.message}</li>
                                                            </ul>
                                                        </div>
                                                    }
                                                    <div className="fv-row mb-8 fv-plugins-icon-container">
                                                        <input
                                                            type="password"
                                                            className="form-control fs-7 fw-normal"
                                                            name="currentPassword"
                                                            placeholder="Current Password"
                                                            value={values.currentPassword}
                                                            onChange={handleChange('currentPassword')}
                                                            autoComplete="new-password"
                                                        />
                                                        <div>
                                                            {touched.currentPassword && errors.currentPassword &&
                                                                <p className='errorMsg'>{errors.currentPassword as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="fv-row mb-8 fv-plugins-icon-container">
                                                        <input
                                                            type="password"
                                                            className="form-control fs-7 fw-normal"
                                                            name="newPassword"
                                                            placeholder="New Password"
                                                            value={values.newPassword}
                                                            onChange={handleChange('newPassword')}
                                                            autoComplete="new-password"
                                                        />
                                                        <div>
                                                            {touched.newPassword && errors.newPassword &&
                                                                <p className='errorMsg'>{errors.newPassword as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="fv-row mb-8 fv-plugins-icon-container">
                                                        <input
                                                            type="password"
                                                            className="form-control fs-7 fw-normal"
                                                            name="verifyPassword"
                                                            placeholder="Re-Type Password"
                                                            value={values.verifyPassword}
                                                            onChange={handleChange('verifyPassword')}
                                                            autoComplete="new-password"
                                                        />
                                                        <div>
                                                            {touched.verifyPassword && errors.verifyPassword &&
                                                                <p className='errorMsg'>{errors.verifyPassword as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="d-grid mb-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-bs-btn-font-weight me-2 fs-6"
                                                            onClick={() => handleSubmit()}
                                                            disabled={!isValid}
                                                        >
                                                            {('Save New Password')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className=" d-flex flex-stack">
                                                <div className="text-gray-500 text-center fs-6 mt-8">
                                                    By clicking Sign In button, I agree to Livetecs
                                                    <a href="https://www.livetecs.com/terms-of-use/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                                                        {('Terms Of Use')}
                                                    </a> and <a href="https://www.livetecs.com/privacy-policy/" target="_blank" className="cursor ms-1 text-gray-500" style={{ fontWeight: 500, textDecorationLine: 'underline' }}>
                                                        {('Privacy Policy')}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}